declare global {
  interface Window {
    __bearer?: Record<string, string>;
  }
}

interface ApiResponse {
  error?: string;
  [key: string]: unknown;
}

export async function api(path: string, body: Record<string, unknown> = {}, token?: string): Promise<ApiResponse> {
  const headers: Record<string, string> = { 'content-type': 'application/json' };
  if (typeof window !== 'undefined' && window.__bearer) {
    Object.assign(headers, window.__bearer);
  }
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  // Map legacy Netlify function names to Render API paths
  const CORE_API = import.meta.env.VITE_CORE_API_URL || '';
  const pathMap: Record<string, string> = {
    'teacher-vendor-card-upsert': '/api/v1/cards/vendor',
    'teacher-session-attach': '/api/v1/shopping/start',
  };
  const resolvedPath = pathMap[path];
  if (!resolvedPath) throw new Error(`Unknown shop API path: ${path}`);
  const baseUrl = CORE_API;
  const response = await fetch(`${baseUrl}${resolvedPath}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body ?? {}),
  });

  const json: ApiResponse = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(json?.error || 'Request failed');
  }
  return json;
}

const amazonUrl =
  import.meta.env.VITE_AMAZON_BUSINESS_URL || 'https://business.amazon.com/';
const walmartUrl =
  import.meta.env.VITE_WALMART_BUSINESS_URL || 'https://business.walmart.com/';

export const vendorCopy = {
  amazon: {
    label: 'Amazon Business',
    openUrl: amazonUrl,
    help: 'Use for Amazon Business carts. A buffer covers tax and shipping.',
  },
  walmart: {
    label: 'Walmart Business',
    openUrl: walmartUrl,
    help: 'Use for Walmart Business orders.',
  },
};
